import styled from 'styled-components'
import { COLOURS } from 'resources'

export const Container = styled.div`
  padding-bottom: 20px;
  width: 100%;
`

export const Title = styled.p`
  color: ${COLOURS.neutralBlack};
  font-family: Druk, sans-serif;
  font-size: 30px;
  line-height: 30px;
  margin-bottom: 10px;
  white-space: pre-wrap;
`
